var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgSoon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 807,
    height: 976,
    viewBox: "0 0 807 976",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97 560.841V572.384L97.0154 572.368C97.0616 573.986 98.1703 575.603 100.326 576.839L134.325 596.292C138.744 598.817 145.904 598.817 150.331 596.292L194.686 566.944C196.972 565.64 198.073 563.908 197.996 562.199V550.695L186.14 556.707L160.679 542.144C156.26 539.618 149.092 539.618 144.673 542.144L105.9 568.31L97 560.841Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.326 556.241L144.68 526.894C149.1 524.369 156.268 524.369 160.679 526.894L194.678 546.339C199.097 548.864 199.097 552.969 194.678 555.494L150.332 584.841C145.912 587.366 138.744 587.366 134.333 584.841L100.326 565.396C95.9069 562.863 95.9069 558.766 100.326 556.241Z",
    fill: "#1E88E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.326 556.241L144.68 526.894C149.1 524.369 156.268 524.369 160.679 526.894L194.678 546.339C199.097 548.864 199.097 552.969 194.678 555.494L150.332 584.841C145.912 587.366 138.744 587.366 134.333 584.841L100.326 565.396C95.9069 562.863 95.9069 558.766 100.326 556.241Z",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.448 571.293L114.345 561.976L137.231 555.915L142.268 559.022L127.008 563.065L137.075 569.274L129.448 571.293Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.23 555.915L145.013 540.536L160.117 549.854L154.924 560.106L147.297 562.124L152.49 551.872L147.453 548.764L142.261 559.016L137.23 555.915Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.305 562.124L152.341 565.232L167.601 561.189L162.564 558.081L147.305 562.124Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.594 561.189L175.377 545.811L165.31 539.602L162.713 544.728L167.75 547.835L162.557 558.087L167.594 561.189ZM157.683 541.62L152.646 538.512L155.243 533.386L160.28 536.494L157.683 541.62Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 33,
    y: 530.25,
    width: 229,
    height: 185.936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 54
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.556863 0 0 0 0 0.972549 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 189.887,
    y1: 541.841,
    x2: 113.814,
    y2: 587.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 100.104,
    y1: 546.28,
    x2: 150.776,
    y2: 577.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSoon3);
export default __webpack_public_path__ + "static/media/img-soon-3.f6231670a81320a4332631e4c11af50a.svg";
export { ForwardRef as ReactComponent };